import { Tag } from "./tag";

import "./comparing.tag.scss";

export const ComparingTag = () => {
  return <Tag className="tx-comparing-tag" value="comparing" />;
};

ComparingTag.propTypes = {};
